const signs = [
  'Руководители постоянно решают задачи сотрудников самостоятельно, вместо того чтобы управлять',
  'Собственник остаётся главным центром принятия всех решений — бизнес не работает без него',
  'Сотрудники боятся принимать решения без согласования — инициатива заблокирована',
  'Руководители перегружены операционными задачами и не успевают заниматься развитием',
  'Задачи регулярно срываются — сроки, качество, приоритеты не соблюдаются',
  'Сотрудники не понимают критериев хорошего результата — каждый делает как считает нужным',
  'Руководители избегают сложных разговоров — проблемы накапливаются и усугубляются',
  'Конфликты внутри команды повторяются — вместо решения их замалчивают или гасят',
  'Новые руководители не готовы к управленческой роли — они действуют как специалисты',
  'Компания быстро растёт, появляются новые подразделения — старые методы управления не работают',
  'Требуется подготовка кадрового резерва — нет системы выращивания будущих руководителей',
  'Собственник хочет выйти из операционного управления — но некому передать ответственность',
];

export default function WhenNeededSection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-6">
          Когда компании необходимо развивать руководителей
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Если вы узнаёте хотя бы несколько из этих ситуаций — управленческая система компании требует развития.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12">
          {signs.map((sign, i) => (
            <div key={i} className="flex items-start gap-3 p-4 bg-gray-50 rounded-xl border border-gray-100">
              <div className="w-7 h-7 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-alert-line text-sm text-red-600"></i>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">{sign}</p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Обсудить управленческую задачу
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}